import useOrdersDashboard from 'features/orders/hooks/useOrdersDashboard';
import { useEffect } from 'react';
import { showOrderCount } from 'utils/dashboardUtils';
import { useShopifyReviewModal } from './useShopifyReviewModal';

/** Shopify's review dialog is only requested once the shop has more orders than this */
const REVIEW_MIN_ORDER_COUNT = 1;

/**
 * Requests Shopify's review dialog once the shop has more than one order (of any status — an empty status counts them
 * all). The orders count's SWR cache is shared between pages, and `useShopifyReviewModal` makes sure the dialog is only
 * requested once per session.
 */
export const useShopifyReviewAfterOrders = () => {
    const openReviewModal = useShopifyReviewModal();
    const { meta } = useOrdersDashboard('');
    const hasEnoughOrders = showOrderCount(meta) > REVIEW_MIN_ORDER_COUNT;

    useEffect(() => {
        if (hasEnoughOrders) {
            openReviewModal();
        }
    }, [hasEnoughOrders, openReviewModal]);
};

export default useShopifyReviewAfterOrders;
